/*
 Created by CHT 2019/9/17 16:11
 单行文本
 */

import {
  DATA_TYPE__STRING,
  DEFAULT_VALUE__CUSTOM,
  DEFAULT_VALUE__FORMULA, DEFAULT_VALUE__ID,
  DEFAULT_VALUE__RELATE_DATA, FORM_ITEM__RELATE_RECORD, FORM_ITEM__RTF, FORM_ITEM__SECTION,
  FORM_ITEM__SINGLE_LINE, FORM_ITEM__TABLE, FORM_STATUS__FILL
} from "../types"
import {defaultValueInit, uuid} from '../utils'
import BaseItem from "../BaseItem"
import Phone from "./Phone"
import {isEmail} from "../../../assets/js/Untis";

class SingleLine extends BaseItem {
  constructor() {
    super()

    // 填写内容
    this.value = ''

    // 校验条件
    this.checkCondition = {
      checkType: "TEXT",
      lengthLimit: 0, 			// 开启长度限制 0 否 1 是
      minLength: 5, 				// 最短
      maxLength: 40, 				// 最长
      regexLimit: 0, 				// 开启正则校验
      regexStr: "" 					// 内置 手机 邮箱 正则 可以自定义
    }

    this.whiteSwitch = 0 // 白名单开关 0 关 1 开
    this.whiteList = [] // 白名单列表
    this.blackSwitch = 0  // 黑名单开关 0 关 1 开
    this.blackList = []  // 黑名单列表

    this.defaultValue = {
      defaultType: ''
    }

    this.scanSwitch = 0 // 扫码输入开关
    this.scanEdit = 0   // 扫码结果可修改
    this.scanType = 0   // 0 条形码 1 二维码

    this.regExpCheckStr = '' // 正则校验未通过提示
    this.lengthCheckStr = ''
  }

  get title() {
    return this.fieldTitle || SingleLine._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }

  // 是否展示必填提示
  get isShowTipsText() {
    return !this.checkWriteValue() || !this.lengthCheck() || !this.regExpCheck() || !this.checkList || this.errorText.length
  }
  get tipsText() {
    if ( this.errorText.length) {
      return ''
    } else if (!this.checkWriteValue()) {
      return this.requiredShowText
    } else if (!this.regExpCheck()) {
      return this.regExpCheckStr
    } else if (!this.lengthCheck()) {
      return this.lengthCheckStr
    } else {
      return '输入数据不合法'
    }
  }
}

SingleLine._title = '单行文本'
SingleLine.type = FORM_ITEM__SINGLE_LINE
SingleLine.use = true
SingleLine.icon = 'iconfont icon-danxingwenben'

// 组件类型
SingleLine.prototype.type = SingleLine.type
// 数据类型
SingleLine.prototype.dataType = DATA_TYPE__STRING
// 正则列表
SingleLine.prototype.defaultValueList = [
  {
    label: '不设置',
    value: {
      defaultType: ''
    }
  },
  {
    label: "自定义",
    value: defaultValueInit(DEFAULT_VALUE__CUSTOM, '')
  },
  {
    label: '公式',
    value: defaultValueInit(DEFAULT_VALUE__FORMULA)
  },
  {
    label: '关联数据',
    value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA)
  },
  {
    label: '自动生成唯一标识符',
    value: {
      defaultType: DEFAULT_VALUE__ID
    }
  }
]
SingleLine.prototype.regexStrList = [
  {
    label: '手机类型',
    value: '^1[3456789]\\d{9}$'
  },
  {
    label: '邮箱类型',
    value: '^\\w+((.\\w+)|(-\\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$'
  }
]
SingleLine.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  },
  {
    name: '等于任意一个',
    method: 'in'
  },
  {
    name: '不等于任意一个',
    method: 'nin'
  },
  {
    name: '包含',
    method: 'like'
  },
  {
    name: '不包含',
    method: 'unlike'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
SingleLine.prototype.getValue = function () {
  return this.value ? String(this.value).trim() :  this.value
}
SingleLine.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  this.value = val ? String(val) : ''
  // 子类调用父类中被覆盖的方法
  // BaseItem.prototype.setValue.apply(this)
}
SingleLine.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    checkCondition: this.checkCondition,
    defaultValue: this.defaultValue,
    whiteSwitch: this.whiteSwitch,
    whiteList: this.whiteList,
    blackSwitch: this.blackSwitch,
    blackList: this.blackList,

    scanSwitch: this.scanSwitch,
    scanEdit: this.scanEdit,
    scanType: this.scanType
  }
}
SingleLine.prototype.setConf = function (opts) {
  this.setBase(opts)
  if (opts.checkCondition) {
    this.checkCondition = opts.checkCondition
  }
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      this.value = this.defaultValue.customValue
    } else if(opts.defaultValue.defaultType === DEFAULT_VALUE__ID) {
      this.value = uuid('No.')
    }
  }
  this.whiteSwitch = opts.whiteSwitch || 0
  this.blackSwitch = opts.blackSwitch || 0
  if (opts.whiteList) this.whiteList = opts.whiteList
  if (opts.blackList) this.blackList = opts.blackList

  this.scanSwitch = opts.scanSwitch || 0 // 扫码输入开关
  this.scanEdit = opts.scanEdit || 0  //扫码结果可修改
  this.scanType = opts.scanType || 0  // 0 条形码 1 二维码
}
SingleLine.prototype.valueToString = function (value) {
  value = value || this.value
  return value
}

// 检查数据合法性 true合法 false不合法
SingleLine.prototype.checkData = function () {
  // 判断必填
  // if (!this.checkWriteValue()) {
  //   return false
  // }

  if (!this.lengthCheck()) {
    return false
  }

  // if (!this.regExpCheck()) {
  //   return false
  // }

  return this.checkList()
}

// 判断必填项
SingleLine.prototype.checkWriteValue = function () {
  if (this.root.status === FORM_STATUS__FILL && this.required && !this.value.length) {
    return false
  } else {
    return true
  }
}

// 正则校验
SingleLine.prototype.regExpCheck = function () {
  // if (this.value.length && this.checkCondition.regexLimit) {
  //   let result = true
  //   if (this.checkCondition.regexStr === '^1[3456789]\\d{9}$') {
  //     result = (new RegExp(this.checkCondition.regexStr)).test(this.value)
  //     this.regExpCheckStr = '请输入正确的手机号'
  //   } else {
  //     result = isEmail(this.value)
  //     this.regExpCheckStr = '请输入正确的邮箱'
  //   }
  //   return result
  // } else {
    return true
  // }
}

// 字数校验
SingleLine.prototype.lengthCheck = function () {
  if (this.checkCondition.lengthLimit) {
    let result = true
    if (this.checkCondition.minLength > this.value.length) {
      result = false
      this.lengthCheckStr = `输入长度不能小于${this.checkCondition.minLength}个字符`
    } else if (this.checkCondition.maxLength < this.value.length) {
      result = false
      this.lengthCheckStr = `输入长度不能大于${this.checkCondition.maxLength}个字符`
    } else {
      result = true
    }
    return result
  } else {
    return true
  }
}

SingleLine.prototype.checkList = function () {
  if (this.whiteSwitch === 1) {
    // 白名单通过就不需要过黑名单了
    if (this.whiteList.includes(this.value)) {
      return true
    } else {
      return false
    }
  } else {
    return this.checkBlackList()
  }
}

// 判断黑名单
SingleLine.prototype.checkBlackList = function () {
  if (this.blackSwitch === 1) {
    if (this.blackList.includes(this.value)) {
      return false
    } else {
      return true
    }
  } else {
    return true
  }
}

export default SingleLine
